module.exports = __webpack_public_path__ + "static/media/classroom.a68be532.png";